<template>
  <div
    class="d-flex align-items-center"
    style="gap: 12px; background-color: #e5eaee; padding: 4px 8px; border-radius: 8px"
  >
    <div v-for="icon in icons" :key="icon.field" v-b-tooltip.hover :title="icon.tooltipTitle">
      <div v-if="getValue(icon) === null">-</div>
      <i v-else :class="iconClasses(icon)"></i>
    </div>
  </div>
</template>
<script>
import { releaseprozessIconClass, isReiseOhneFlug } from '@/core/common/helpers/utils';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      allIcons: [
        {
          field: 'teilnehmerdatenStatus',
          icon: 'fas fa-user-check fa-lg',
          tooltipTitle: 'Teilnehmerdaten',
        },
        {
          field: 'reiseleistungListenversandStatus',
          icon: 'fas fa-suitcase fa-lg',
          tooltipTitle: 'Reiseleistung und Listenversand',
        },
        {
          field: 'fluegeStatus',
          icon: 'fas fa-plane fa-lg',
          tooltipTitle: 'Flüge',
        },
        {
          field: 'transferplanungStatus',
          icon: 'fas fa-car fa-lg',
          tooltipTitle: 'Transferplanung Vorgangsebene',
        },
        {
          field: 'hotelsUndProgrammGeprueft',
          icon: 'far fa-list-alt fa-lg',
          type: 'reisetermin',
          tooltipTitle: 'Reiseunterlagen',
        },
        {
          field: 'transferplanungGeprueft',
          icon: 'fas fa-bus fa-lg',
          type: 'reisetermin',
          tooltipTitle: 'Finale Transferplanung',
        },
      ],
    };
  },
  props: {
    reiseterminObject: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({ vorgaenge: state => state.vorgaenge.vorgaenge }),
    isReiseOhneFlugMitTransfer() {
      return isReiseOhneFlug(this.reiseterminObject?.metadata);
    },
    icons() {
      if (this.isReiseOhneFlugMitTransfer) {
        return this.allIcons.filter(
          icon => icon.field !== 'fluegeStatus' && icon.field !== 'transferplanungStatus'
        );
      }
      return this.allIcons;
    },
  },
  methods: {
    getValue(icon) {
      if (this.reiseterminObject?.pax?.ist === 0 && icon.type != 'reisetermin') {
        return null;
      }
      // Alle sechs Felder liegen in releaseprozessStatus, dem reisetermin-Teil der Route releaseprozessStatus
      const value = this.reiseterminObject?.releaseprozessStatus?.[icon.field];
      // wenn es reisetermin felder sind, die nur boolean sind, werden diese in die Strings umgewandelt
      if (typeof value === 'boolean') {
        return value ? 'AllGood' : 'Critical';
      }
      // normalen strings ['AllGood', etc.] für die vorgangReleaseIcons
      // Fehlt der Status, wird null zurückgegeben, damit das Template '-' statt eines roten Icons zeigt
      return value ?? null;
    },
    iconClasses(icon) {
      const value = this.getValue(icon);
      return releaseprozessIconClass({ icon: icon.icon, value });
    },
  },
};
</script>
